export const premiumFeatures = [
    {
        api_name: 'whitelabel',
        label: 'Whitelabel',
        type: 'checkbox',
    },
]
